import { createContext } from 'react';

const RecipeContext = createContext();

export default RecipeContext;
